import type { FC } from 'react'

import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import {
  conversationSelector,
  uiStateSelector,
  useStore,
} from '@liveHelper/models/store'
import { PRIVACY_ALERT } from '@liveHelper/testIds'

import { useLocalStorage } from '@core/hooks/useLocalStorage'

import { PrivacyAlertContainer, StyledMarkdown } from './PrivacyAlert.styles'

interface PrivacyAlertProps {
  hasContainer?: boolean
}

/** Privacy alert component providing links to privacy documents. */
export const PrivacyAlert: FC<PrivacyAlertProps> = ({
  hasContainer = true,
}) => {
  const data = useChatChannelConfig()
  const legalStatement = data?.config?.legal_statement

  const [lastEngagedConversation] = useLocalStorage('lastEngagedConversation')
  const conversation = useStore(conversationSelector)
  const uiState = useStore(uiStateSelector)

  if (
    conversation &&
    conversation.id === lastEngagedConversation &&
    uiState !== 'dialing_expanded'
  ) {
    return null
  }

  if (legalStatement) {
    return (
      <PrivacyAlertContainer
        data-testid={PRIVACY_ALERT}
        hasContainer={hasContainer}
      >
        <StyledMarkdown>{legalStatement}</StyledMarkdown>
      </PrivacyAlertContainer>
    )
  }

  return null
}
